module.exports = __webpack_public_path__ + "img/ocsvg.98bf3136.svg";